import BaseService from "src/packages/BaseService";

export default class MediaService extends BaseService {
	static get className () {
		return "media";
	}
};
